var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradientBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 792.358 8",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".topbar-cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 102.487,
    y1: 682.662,
    x2: 107.066,
    y2: -63.658,
    gradientTransform: "translate(710.224 -101.177) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#e47864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#bb4e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#884953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#5d4558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#3f425c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#2d405e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#263f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#1a516c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00788a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#009595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#0a9794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#259d93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#51a790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#75af8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98c3ac"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "topbar-cls-1",
    y: 0.025,
    width: 792.358,
    height: 8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBar);
export default __webpack_public_path__ + "static/media/gradientBar.9ae9be6a.svg";
export { ForwardRef as ReactComponent };